import type { PriceData } from '../../../../common/models/priceData/priceData';

export const getAdjustedPercentageForHistoricalPricePromo = ({
    percentage,
    adjustedPercentage,
    historicalPriceData,
}: {
    percentage: number;
    adjustedPercentage: number | undefined;
    historicalPriceData: PriceData | undefined;
}) => {
    let finalPercantage = percentage;

    if (historicalPriceData && adjustedPercentage !== undefined && adjustedPercentage > 0) {
        finalPercantage = adjustedPercentage;
    }

    return finalPercantage;
};

export const getPiecePriceForHigherThanHistoricalPrice = ({
    isMemberPrice,
    newPiecePrice,
    piecePrice,
    isUserMember,
}: {
    isMemberPrice: boolean;
    newPiecePrice: PriceData | undefined;
    piecePrice: PriceData | undefined;
    isUserMember: boolean;
}) => {
    let finalPiecePrice = newPiecePrice;

    if (isMemberPrice && !isUserMember) {
        finalPiecePrice = piecePrice;
    }

    return finalPiecePrice;
};

export const getComparativePriceForHigherThanHistoricalPrice = ({
    isPromoMemberPrice,
    isUserMember,
    comparativePriceData,
    promoComparativePriceData,
}: {
    isUserMember: boolean;
    isPromoMemberPrice: boolean;
    comparativePriceData: PriceData | undefined;
    promoComparativePriceData: PriceData | undefined;
}) => {
    let finalComparativePrice = promoComparativePriceData;

    if (isPromoMemberPrice && !isUserMember) {
        finalComparativePrice = comparativePriceData;
    }

    return finalComparativePrice;
};
